import { type User, login } from '@dtx-company/ithaca-sdk/src'
import {
  auth_signin_form_emailpassword_failure,
  auth_signin_form_emailpassword_started,
  auth_signin_form_emailpassword_success
} from '../../constants/authHeapEvents'
import { fireAnalyticsEvent } from '../../event-tracking/helpers/fireAnalyticsEvent'
import { logger } from '@dtx-company/logger'
import { useCallback } from 'react'
import { useRouter } from 'next/router'

export interface UseLoginProps {
  values: {
    email: string
    password: string
  }
}

export function useLogin(): ({ values }: UseLoginProps) => Promise<{
  user: User
  errors: string[]
  accessToken: string | undefined
}> {
  const { pathname } = useRouter()

  return useCallback(
    async ({ values }) => {
      try {
        const { email, password } = values
        fireAnalyticsEvent(auth_signin_form_emailpassword_started, {
          page: pathname
        })

        const { errors, shouldActivate, accessToken } = await login({
          email,
          password
        })

        fireAnalyticsEvent(auth_signin_form_emailpassword_success, {
          page: pathname
        })

        const user: User = { email, shouldActivate }

        return { user, errors, accessToken }
      } catch (e) {
        fireAnalyticsEvent(auth_signin_form_emailpassword_failure, {
          page: pathname
        })

        logger.logError(e, { technicalArea: 'general' })

        return {
          user: { email: null, shouldActivate: false },
          errors: [],
          accessToken: undefined
        }
      }
    },
    [pathname]
  )
}
